import CHIPS_KEYBOARD_NAV from "./_chips-keyboardnav.js";
export default class {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPSMENU";
		this.init();
	}

	init() {
		this.bindEvents(true);
	}

	bindEvents(bindDirection) {
		let kbNav = CHIPS_KEYBOARD_NAV.init();

		this.menuToggle = document.querySelector(".menu-toggle");
		this.menuToggleAlt = document.querySelector(".menu-toggle-alt");
		this.elBody = document.querySelector("body");

		if (!this.menuToggle) {
			return false;
		}
		if (!this.menuToggleAlt) {
			return false;
		}

		this.menuToggle.addEventListener(
			"click",
			() => {
				if (this.elBody.classList.contains("menu-on")) {
					this.elBody.classList.remove("menu-on");
				} else {
					this.elBody.classList.add("menu-on", "menu-ani");
				}
			},
			false
		);
		this.menuToggleAlt.addEventListener(
			"click",
			() => {
				if (this.elBody.classList.contains("menu-on")) {
					this.elBody.classList.remove("menu-on");
				} else {
					this.elBody.classList.add("menu-on", "menu-ani");
				}
			},
			false
		);

		document.querySelector(".nav-bg").addEventListener(
			"click",
			() => {
				this.elBody.classList.remove("menu-on");
			},
			false
		);
		$(".nav-bg").on("click", function () {
			$("body").removeClass("menu-on");
		});

		let scrollPosOld = 0;
		let scrollPosNew = 0;
		let scrollDelta = 0;
		let scrollThreshold = 20;
		let scrollDown = false;
		window.addEventListener("scroll", (e) => {
			scrollPosNew = window.pageYOffset;
			let distanceTraveled = scrollDelta - scrollPosNew;
			if (window.pageYOffset > 500) {
				if (distanceTraveled <= -1 * scrollThreshold) {
					// console.log("Down");
					scrollDelta = scrollPosNew;
					scrollDown = true;
					$(".stick-header").removeClass("scrollup");
				} else if (distanceTraveled >= scrollThreshold) {
					// console.log("Up");
					scrollDelta = scrollPosNew;
					scrollDown = false;
					$(".stick-header").addClass("scrollup");
				}
			} else {
				scrollDelta = scrollPosNew;
				scrollDown = false;
				$(".stick-header").removeClass("scrollup");
			}
			// console.log(distanceTraveled);
			// if (scrollPosOld < scrollPosNew) {
			// 	console.log("Up");
			// } else if (scrollPosOld > scrollPosNew) {
			// 	console.log("Down");
			// }
			scrollPosOld = scrollPosNew;
		});
	}
	destroy() {
		this.bindEvents(false);
	}
}
